import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';

function AppraiseTabContentFormWrapperBase({ children, isFullWidth = false, isVdp = false }) {
  if (isFullWidth) {
    return <div>{children}</div>;
  }

  return (
    <Row>
      <Col xs={12} md={9} lg={isVdp ? undefined : 8}>
        {children}
      </Col>
    </Row>
  );
}

AppraiseTabContentFormWrapperBase.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  isFullWidth: PropTypes.bool,
  isVdp: PropTypes.bool,
};

export const AppraiseTabContentFormWrapper = memo(AppraiseTabContentFormWrapperBase);

export function AppraiseTabContentVdpFormWrapper({ children, isFullWidth = false }) {
  return (
    <AppraiseTabContentFormWrapper isFullWidth={isFullWidth} isVdp>
      {children}
    </AppraiseTabContentFormWrapper>
  );
}

AppraiseTabContentVdpFormWrapper.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  isFullWidth: PropTypes.bool,
};
